import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { WindowService } from 'shared/services/window/window.service';

const tooltipParentCssClass = 'tooltip-parent';
const WINDOW_PADDING = 20;

@Component({
  selector: 'ng2-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TooltipComponent implements OnInit, OnDestroy {
  @Input() text: string;
  @Input() direction: string;
  @Input() hideArrow = false;
  @Input() align: string;

  @ViewChild('tooltipText')
  tooltipText: ElementRef;

  @ViewChild('tooltip', {static: true})
  tooltip: ElementRef;

  public top: number;
  public left: number;
  public tooltipTextTop: number;
  public tooltipTextLeft: number;

  private _removeParentListener;

  constructor(private elRef: ElementRef,
              private renderer: Renderer2,
              private changeDetector: ChangeDetectorRef,
              private _window: WindowService) {
  }

  ngOnInit() {
    this._removeParentListener = this.renderer.listen(this.parent, 'mouseenter', () => {
      this._setPosition();
    });
    this._setPosition();
    this.parent.classList.add(tooltipParentCssClass);
  }

  ngOnDestroy() {
    this._removeParentListener();
  }

  get parent() {
    return this.elRef.nativeElement.parentElement;
  }

  public hasBottomDirection(): boolean {
    return this.direction === 'bottom';
  }

  private _getParentClientRects() {
    return this.parent.getClientRects()[0];
  }

  private _setPosition() {
    const parentClientRects = this._getParentClientRects();
    if (!parentClientRects) {
      return;
    }
    this._setTooltipTextPositionsToZero();

    const parentWidth = parentClientRects.width;
    const parentHeight = parentClientRects.height;

    const isLeft = this.direction === 'left';
    const isRight = this.direction === 'right';
    const isBottom = this.direction === 'bottom';
    const isTop = this.direction === 'top';

    this.changeDetector.detectChanges();
    const rect = this.tooltipText.nativeElement.getBoundingClientRect();

    if (isLeft || isRight) {
      this.top = parentClientRects.top + parentHeight / 2;
      this.left = parentClientRects.left + (isRight ? parentWidth : 0);
    } else if (isBottom || isTop) {
      this.top = parentClientRects.top + (isBottom ? parentHeight : 0);
      if(this.align ==='right') {
        this.left = parentClientRects.left + rect.width / 2 + parentWidth / 2;
      } else if(this.align === 'left') {
        this.left = parentClientRects.left - rect.width / 2 + parentWidth / 2;
      } else {
        this.left = parentClientRects.left + parentWidth / 2;
      }
    }

    this._adjustTooltipPosition(rect);
    this.changeDetector.detectChanges();
  }

  private _adjustTooltipPosition (rect) {
    if (rect.top < 0 + WINDOW_PADDING) {
      this.tooltipTextTop = -rect.top + WINDOW_PADDING;
    }
    if (rect.left < 0 + WINDOW_PADDING) {
      this.tooltipTextLeft = -rect.left + WINDOW_PADDING;
    }
    if (rect.bottom > (this._window.innerHeight || document.documentElement.clientHeight) - WINDOW_PADDING) {
      this.tooltipTextTop = (this._window.innerHeight || document.documentElement.clientHeight) - rect.bottom - WINDOW_PADDING;
    }
    if (rect.right > (this._window.innerWidth || document.documentElement.clientWidth) - WINDOW_PADDING) {
      this.tooltipTextLeft = (this._window.innerWidth || document.documentElement.clientWidth) - rect.right - WINDOW_PADDING;
    }
  }

  private _setTooltipTextPositionsToZero () {
    this.tooltipTextTop = 0;
    this.tooltipTextLeft = 0;
  }

}
